import React from 'react';
import { IconProps } from '@/shared/types/icon';

const MailIcon: React.FC<IconProps> = ({
    size = 24,
    color = 'currentColor',
    width = 24,
    height = 24,
    ...props
}) => {
    return (
        <svg
            width={size || width}
            height={size || height}
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path d='M2.66634 13.3337C2.29967 13.3337 1.9859 13.2032 1.72501 12.9423C1.46412 12.6814 1.33345 12.3674 1.33301 12.0003V4.00033C1.33301 3.63366 1.46367 3.31988 1.72501 3.05899C1.98634 2.7981 2.30012 2.66744 2.66634 2.66699H13.333C13.6997 2.66699 14.0137 2.79766 14.275 3.05899C14.5363 3.32033 14.6668 3.6341 14.6663 4.00033V12.0003C14.6663 12.367 14.5359 12.681 14.275 12.9423C14.0141 13.2037 13.7001 13.3341 13.333 13.3337H2.66634ZM7.99967 8.66699L13.333 5.33366V4.00033L7.99967 7.33366L2.66634 4.00033V5.33366L7.99967 8.66699Z' fill='#5C5858' />
        </svg>
    );
};

export default MailIcon;
